module.exports = __webpack_public_path__ + "img/arcos-c.273e3f7e.jpg";